class Carousel {
    constructor() {
        this.class = {
            carousel: '.js-carousel',
            carouselItem: '.js-carousel-item',
            carouselControlNext: '.carousel-control-next',
            carouselControlPrev: '.carousel-control-prev',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * Add keyboard controls for more accessibility
     */
    addKeyboardControlls(carousel) {
        carousel.forEach((carouselItem) => {
            carouselItem.addEventListener('keyup', (event) => {
                if (event.defaultPrevented) {
                    return; // Should do nothing if the default action has been cancelled
                }

                let handled = false;
                const key = event.key || event.code || event.keyCode;

                if (key === 'ArrowRight' || key === 39) {
                    document.querySelector(this.class.carouselControlNext).click();
                    handled = true;
                } else if (key === 'ArrowLeft' || key === 37) {
                    document.querySelector(this.class.carouselControlPrev).click();

                    handled = true;
                }

                if (handled) {
                    // Suppress "double action" if event handled
                    event.preventDefault();
                }
            });
        });
    }

    /**
     * function to iterate through all carousel items
     * and set all elements on same max height
     */
    setEqualHeights(carouselEl) {
        function setHeight(el, val) {
            if (typeof val === 'function') val = val();
            if (typeof val === 'string') el.style.height = val;
            else el.style.height = `${val}px`;
        }

        let currentTallest = 0;
        const elements = [];
        let currentDiv;

        carouselEl.querySelectorAll(this.class.carouselItem).forEach((el, index) => {
            el.style.height = 'auto';
            // we need to activate all carousel items to get the height of the element
            el.classList.add('active');
            elements.push(el);
            currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', '')))
                ? (parseFloat(getComputedStyle(el, null).height.replace('px', '')))
                : (currentTallest);
            for (currentDiv = 0; currentDiv < elements.length; currentDiv += 1) {
                setHeight(elements[currentDiv], currentTallest);
            }
            if (index !== 0) {
                // hide all items but first one
                el.classList.remove('active');
            }
        });
    }

    init() {
        const carousel = document.querySelectorAll(this.class.carousel);
        if (carousel.length > 0) {
            this.addKeyboardControlls(carousel);

            // iterates through all carousel elements
            carousel.forEach((carouselEl) => {
                window.addEventListener('load', () => {
                    this.setEqualHeights(carouselEl);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        this.setEqualHeights(carouselEl);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        this.setEqualHeights(carouselEl);
                    });
                });
            });
        }
    }
}

export default new Carousel();
